// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header__sectionSmall___NhBEC {
}

.Header__row___asLmr {
}

.Header__ticketFlag___AS4bU {
  display: inline-block;
  height: 25px;
  margin: 0;
  padding: 0;
}

.Header__ticketFlag___AS4bU img {
    height: 25px;
    margin-right: 5px;
  }

.Header__boxLabel___ajNTY {
  line-height: 26px;
  margin: 0;
}

.Header__accountBoxLabel___TJ5XD {
  font-weight: 700;
  text-transform: uppercase;
}

.Header__accountStatusCaption___WDdDC {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  opacity: 0.75;
  font-size: 11px;
}

.Header__headerLight___vC1DO {
  margin-top: 5px;
  color: #7d7d7d;
}

.Header__headerLight___vC1DO h4 {
    margin-top: 3px;
    font-weight: 400;
  }

.Header__nameWrapper___G7aaT {
  width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
  padding: 16px;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
}

.Header__nameWrapper___G7aaT:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.Header__nameWrapper___G7aaT:last-child {
  margin-right: 0;
}

.Header__nameWrapper___G7aaT:nth-child(1n) {
  margin-right: 0;
  float: right;
}

.Header__nameWrapper___G7aaT:nth-child(1n + 1) {
  clear: both;
}

.Header__nameWrapper___G7aaT .Header__boxLabel___ajNTY {
    margin-right: 20px;
  }

.Header__beneName___UgPoU {
  box-shadow: none;
  color: text;
}

.Header__accountNumberLink___ibzzl {
  box-shadow: none;
}

.Header__accountNumberLink___ibzzl:hover {
    box-shadow: none !important;
  }

.Header__redirectIcon___xKptq {
  margin: 0 -10px 0 0 !important;
  box-shadow: none;
}

.Header__redirectIcon___xKptq:hover {
    box-shadow: none !important;
  }

.Header__balanceWrapper___Myk64 {
  width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
}

.Header__balanceWrapper___Myk64:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.Header__balanceWrapper___Myk64:last-child {
  margin-right: 0;
}

.Header__balanceWrapper___Myk64:nth-child(1n) {
  margin-right: 0;
  float: right;
}

.Header__balanceWrapper___Myk64:nth-child(1n + 1) {
  clear: both;
}

.Header__accountStatusWrapper___qOHKS {
  width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.5px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
}

.Header__accountStatusWrapper___qOHKS:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.Header__accountStatusWrapper___qOHKS:last-child {
  margin-right: 0;
}

.Header__accountStatusWrapper___qOHKS:nth-child(1n) {
  margin-right: 0;
  float: right;
}

.Header__accountStatusWrapper___qOHKS:nth-child(1n + 1) {
  clear: both;
}

.Header__standardHeight___MDBrp {
  min-height: 100px;
}

.Header__trusts___RDvzB {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -5px;
  width: 100%;
}
.Header__trustsHeader___PIyu2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
}

.Header__accountNumberRow___XFlg9 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.Header__accountNumberRow___XFlg9 .Header__accountNumberLink___ibzzl {
  margin-right: 0;
}

.Header__trusts___RDvzB a {
  margin: 0 10px 0 0;
}

.Header__trustsItem___SD3h4 {
  margin: 0 10px;
  display: inline-block;
  vertical-align: middle;
}

.Header__titleBox___UwYnp {
  position: relative;
  height: calc(100vh - 151px);
  display: flex;
  justify-content: center;
  align-items: baseline;
  overflow-y: auto;
  background-color: rgba(255, 255, 255, 0.887);
}

.Header__titleBox___UwYnp .styles__collapseRef___PvDYq {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

.Header__titleHeaderHeight___EprBC {
  height: calc(100vh - 65px) !important;
}

.Header__titleBoxRow___Lpsdi {
  width: 100%;
}

.Header__titleName___oPOrx {
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
}

.Header__accountNumberLine___kCp67 {
  display: flex;
  align-items: center;
  justify-content: left;
  margin-top: 8px;
}

.Header__accountNumber___Oi4V7 {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  padding: 2px 4px;
  vertical-align: middle;
}

.Header__newAccountBadge___yNZxw {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  margin: 0;
  padding: 2px 4px;
  vertical-align: middle;
}

.Header__closedStatus___fTQab {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 10px;
  padding: 2px 4px;
  vertical-align: middle;
}

.Header__closingStatus___WVKNz {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 10px;
  padding: 2px 4px;
  vertical-align: middle;
}

.Header__deceasedFlag___XUujd {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
  border-radius: 3px;
  color: white;
  display: inline-block;
  float: left;
  margin-bottom: 5px;
  margin-left: 10px;
  padding: 2px 4px;
  vertical-align: middle;
}

.Header__trustName___TwOXa {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
}

.Header__accountBoxStatus___AER_b {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  text-align: right;
}

.Header__accountBoxStatus___AER_b:before {
  content: '';
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 5px 5px 0 0;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  border-radius: 100%;
}

.Header__productDescription___VPGOC {
  margin-top: 12px;
}

.Header__accountStatusOption___WPraz {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  font-size: 1rem;
  margin-left: 30px;
}

.Header__accountStatusOption___WPraz:before {
  content: '';
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  margin-right: 10px;
  content: '\\2713';
  color: white;
  padding: 1px 3px;
  font-size: 12px;
}

.Header__sectionHeader___nba8U {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]} !important;
  border-bottom: 1px solid rgba(73, 80, 84, 0.15);
  border-radius: 4px 4px 0 0 !important;
}

.Header__sectionHeader___nba8U h5 {
    border-radius: 4px 4px 0 0 !important;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]} !important;
    padding: 20px 16px;
  }

.Header__sectionHeader___nba8U span {
    padding-right: 16px;
  }

.Header__subAccount___cz3iM {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  opacity: 0.6;
}

.Header__rowHeader___MkDK7 {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.Header__singleLine___uMBYO {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.Header__singleLine___uMBYO:not(:last-child) {
    border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]};
  }
.Header__singleLine___uMBYO div.Header__label___IZ4TE {
    font-size: 14px;
    color: text;
    opacity: 0.9;
  }
.Header__rowError___F7Qqp {
}
.Header__rowError___F7Qqp .Header__value___QWype,
  .Header__rowError___F7Qqp .Header__label___IZ4TE {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }
.Header__rowError___F7Qqp .Header__error___BU27z {
    font-weight: bold;
  }

.Header__valueMono___yg3eI {
  font-family: MaisonMono, monospace;
}

.Header__valueBlank___TYLE6 {
  color: #eee;
}

.Header__valueBold___ZpIWJ {
  color: gtBlueDark;
  font-weight: bold;
}

.Header__valueAlert___c0cBs {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Distributions/components/Header/Header.css"],"names":[],"mappings":"AAIA;AAEA;;AAEA;AAEA;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,UAAU;AAMZ;;AAJE;IACE,YAAY;IACZ,iBAAiB;EACnB;;AAGF;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oDAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAMhB;;AAJE;IACE,eAAe;IACf,gBAAgB;EAClB;;AAGF;EACE,8CAAgB;EAChB,aAAa;EACb,qEAA+B;AAKjC;;AARA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAOlB;;AARA;EACE,eAAgB;AAOlB;;AARA;EACE,eAAgB;EAAhB,YAAgB;AAOlB;;AARA;EACE,WAAgB;AAOlB;;AAHE;IACE,kBAAkB;EACpB;;AAGF;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAIlB;;AAHE;IACE,2BAA2B;EAC7B;;AAGF;EACE,8BAA8B;EAC9B,gBAAgB;AAIlB;;AAHE;IACE,2BAA2B;EAC7B;;AAGF;EACE,8CAAgB;EAChB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qEAA+B;AACjC;;AAPA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAMlB;;AAPA;EACE,eAAgB;AAMlB;;AAPA;EACE,eAAgB;EAAhB,YAAgB;AAMlB;;AAPA;EACE,WAAgB;AAMlB;;AAEA;EACE,8CAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uEAAiC;AACnC;;AAPA;EACE,WAAgB;EAAhB,kBAAgB;EAAhB,WAAgB;AAMlB;;AAPA;EACE,eAAgB;AAMlB;;AAPA;EACE,eAAgB;EAAhB,YAAgB;AAMlB;;AAPA;EACE,WAAgB;AAMlB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EAEE,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;AAO9C;;AALE;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,kCAAkC;EACpC;;AAGF;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,wDAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wDAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mDAAa;AACf;;AAEA;EACE,mDAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8DAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8DAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0EAA2C;EAC3C,+CAA+C;EAC/C,qCAAqC;AAUvC;;AARE;IACE,qCAAqC;IACrC,0EAA2C;IAC3C,kBAAkB;EACpB;;AACA;IACE,mBAAmB;EACrB;;AAGF;EACE,oDAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAWhC;AATE;IACE,qEAAyC;EAC3C;AAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;AAEF;AAWA;AARE;;IAEE,mDAAY;EACd;AAEA;IACE,iBAAiB;EACnB;;AAGF;EAEE,kCAAkC;AACpC;;AAEA;EACE,WAAW;AAEb;;AAEA;EACE,iBAAiB;EAEjB,iBAAiB;AACnB;;AAEA;EACE,mDAAY;EAEZ,iBAAiB;AACnB","sourcesContent":["@value helpers: 'styles/helpers.css';\n@value colors: 'styles/colors.css';\n@value gtGPT, gtBlue, gtRed, gtRedDark, gtYellowDark,borderColorLight, textLight, gtGreen, gtGray, gtGrayLight, gtGrayDark, gtCardHeaderBG from colors;\n\n.sectionSmall {\n  composes: sectionSmall from helpers;\n}\n\n.row {\n  composes: row from helpers;\n}\n\n.ticketFlag {\n  display: inline-block;\n  height: 25px;\n  margin: 0;\n  padding: 0;\n\n  & img {\n    height: 25px;\n    margin-right: 5px;\n  }\n}\n\n.boxLabel {\n  line-height: 26px;\n  margin: 0;\n}\n\n.accountBoxLabel {\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.accountStatusCaption {\n  color: gtGrayDark;\n  opacity: 0.75;\n  font-size: 11px;\n}\n\n.headerLight {\n  margin-top: 5px;\n  color: #7d7d7d;\n\n  & h4 {\n    margin-top: 3px;\n    font-weight: 400;\n  }\n}\n\n.nameWrapper {\n  lost-column: 1/1;\n  padding: 16px;\n  border-bottom: 1px solid gtGray;\n\n  .boxLabel {\n    margin-right: 20px;\n  }\n}\n\n.beneName {\n  box-shadow: none;\n  color: text;\n}\n\n.accountNumberLink {\n  box-shadow: none;\n  &:hover {\n    box-shadow: none !important;\n  }\n}\n\n.redirectIcon {\n  margin: 0 -10px 0 0 !important;\n  box-shadow: none;\n  &:hover {\n    box-shadow: none !important;\n  }\n}\n\n.balanceWrapper {\n  lost-column: 1/1;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid gtGray;\n}\n\n.accountStatusWrapper {\n  lost-column: 1/1;\n  padding: 0 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 0.5px solid gtGray;\n}\n\n.standardHeight {\n  min-height: 100px;\n}\n\n.trusts {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -5px;\n  width: 100%;\n}\n.trustsHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  cursor: pointer;\n}\n\n.accountNumberRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.accountNumberRow .accountNumberLink {\n  margin-right: 0;\n}\n\n.trusts a {\n  margin: 0 10px 0 0;\n}\n\n.trustsItem {\n  margin: 0 10px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.titleBox {\n  composes: sectionSmall row;\n  position: relative;\n  height: calc(100vh - 151px);\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  overflow-y: auto;\n  background-color: rgba(255, 255, 255, 0.887);\n\n  :global(.styles__collapseRef___PvDYq) {\n    border: none !important;\n    box-shadow: none !important;\n    background: transparent !important;\n  }\n}\n\n.titleHeaderHeight {\n  height: calc(100vh - 65px) !important;\n}\n\n.titleBoxRow {\n  width: 100%;\n}\n\n.titleName {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 5px;\n}\n\n.accountNumberLine {\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  margin-top: 8px;\n}\n\n.accountNumber {\n  background: gtGPT;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.newAccountBadge {\n  background: gtRed;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  margin: 0;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.closedStatus {\n  background: gtRedDark;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-left: 10px;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.closingStatus {\n  background: gtYellowDark;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  margin-bottom: 5px;\n  margin-left: 10px;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.deceasedFlag {\n  background: gtRedDark;\n  border-radius: 3px;\n  color: white;\n  display: inline-block;\n  float: left;\n  margin-bottom: 5px;\n  margin-left: 10px;\n  padding: 2px 4px;\n  vertical-align: middle;\n}\n\n.trustName {\n  color: gtBlue;\n}\n\n.accountBoxStatus {\n  color: gtGreen;\n  text-align: right;\n}\n\n.accountBoxStatus:before {\n  content: '';\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  margin: 5px 5px 0 0;\n  background-color: gtGreen;\n  border-radius: 100%;\n}\n\n.productDescription {\n  margin-top: 12px;\n}\n\n.accountStatusOption {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 0;\n  font-size: 1rem;\n  margin-left: 30px;\n}\n\n.accountStatusOption:before {\n  content: '';\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  background-color: gtGreen;\n  margin-right: 10px;\n  content: '\\2713';\n  color: white;\n  padding: 1px 3px;\n  font-size: 12px;\n}\n\n.sectionHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: gtCardHeaderBG !important;\n  border-bottom: 1px solid rgba(73, 80, 84, 0.15);\n  border-radius: 4px 4px 0 0 !important;\n\n  h5 {\n    border-radius: 4px 4px 0 0 !important;\n    background-color: gtCardHeaderBG !important;\n    padding: 20px 16px;\n  }\n  span {\n    padding-right: 16px;\n  }\n}\n\n.subAccount {\n  color: gtGrayDark;\n  opacity: 0.6;\n}\n\n.rowHeader {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n}\n.singleLine {\n  display: flex;\n  width: 100%;\n  height: 40px;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid borderColorLight;\n  }\n\n  div.label {\n    font-size: 14px;\n    color: text;\n    opacity: 0.9;\n  }\n}\n.rowError {\n  composes: row;\n\n  .value,\n  .label {\n    color: gtRed;\n  }\n\n  .error {\n    font-weight: bold;\n  }\n}\n\n.valueMono {\n  composes: value;\n  font-family: MaisonMono, monospace;\n}\n\n.valueBlank {\n  color: #eee;\n  composes: value;\n}\n\n.valueBold {\n  color: gtBlueDark;\n  composes: value;\n  font-weight: bold;\n}\n\n.valueAlert {\n  color: gtRed;\n  composes: value;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `'styles/helpers.css'`,
	"colors": `'styles/colors.css'`,
	"gtGPT": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGPT"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtRedDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"borderColorLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColorLight"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGrayLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayLight"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"sectionSmall": `Header__sectionSmall___NhBEC ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]}`,
	"row": `Header__row___asLmr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"ticketFlag": `Header__ticketFlag___AS4bU`,
	"boxLabel": `Header__boxLabel___ajNTY`,
	"accountBoxLabel": `Header__accountBoxLabel___TJ5XD`,
	"accountStatusCaption": `Header__accountStatusCaption___WDdDC`,
	"headerLight": `Header__headerLight___vC1DO`,
	"nameWrapper": `Header__nameWrapper___G7aaT`,
	"beneName": `Header__beneName___UgPoU`,
	"accountNumberLink": `Header__accountNumberLink___ibzzl`,
	"redirectIcon": `Header__redirectIcon___xKptq`,
	"balanceWrapper": `Header__balanceWrapper___Myk64`,
	"accountStatusWrapper": `Header__accountStatusWrapper___qOHKS`,
	"standardHeight": `Header__standardHeight___MDBrp`,
	"trusts": `Header__trusts___RDvzB`,
	"trustsHeader": `Header__trustsHeader___PIyu2`,
	"accountNumberRow": `Header__accountNumberRow___XFlg9`,
	"trustsItem": `Header__trustsItem___SD3h4`,
	"titleBox": `Header__titleBox___UwYnp Header__sectionSmall___NhBEC ${___CSS_LOADER_ICSS_IMPORT_1___.locals["sectionSmall"]} Header__row___asLmr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"titleHeaderHeight": `Header__titleHeaderHeight___EprBC`,
	"titleBoxRow": `Header__titleBoxRow___Lpsdi`,
	"titleName": `Header__titleName___oPOrx`,
	"accountNumberLine": `Header__accountNumberLine___kCp67`,
	"accountNumber": `Header__accountNumber___Oi4V7`,
	"newAccountBadge": `Header__newAccountBadge___yNZxw`,
	"closedStatus": `Header__closedStatus___fTQab`,
	"closingStatus": `Header__closingStatus___WVKNz`,
	"deceasedFlag": `Header__deceasedFlag___XUujd`,
	"trustName": `Header__trustName___TwOXa`,
	"accountBoxStatus": `Header__accountBoxStatus___AER_b`,
	"productDescription": `Header__productDescription___VPGOC`,
	"accountStatusOption": `Header__accountStatusOption___WPraz`,
	"sectionHeader": `Header__sectionHeader___nba8U`,
	"subAccount": `Header__subAccount___cz3iM`,
	"rowHeader": `Header__rowHeader___MkDK7`,
	"singleLine": `Header__singleLine___uMBYO`,
	"label": `Header__label___IZ4TE`,
	"rowError": `Header__rowError___F7Qqp Header__row___asLmr ${___CSS_LOADER_ICSS_IMPORT_1___.locals["row"]}`,
	"value": `Header__value___QWype`,
	"error": `Header__error___BU27z`,
	"valueMono": `Header__valueMono___yg3eI Header__value___QWype`,
	"valueBlank": `Header__valueBlank___TYLE6 Header__value___QWype`,
	"valueBold": `Header__valueBold___ZpIWJ Header__value___QWype`,
	"valueAlert": `Header__valueAlert___c0cBs Header__value___QWype`
};
export default ___CSS_LOADER_EXPORT___;
